export const defaultPrimaryPusherConfig = {
  key: window.SS_GLOBALS.frontEndConfig.pusherKey,
  cluster: window.SS_GLOBALS.frontEndConfig.pusherCluster,
};

export const buildDefaultPusherConfigs = () => {
  return [defaultPrimaryPusherConfig];
};
